<template>
  <div class="about-container">
    <div class="about">
      <h1 class="title">{{ $t('aboutUBPay.title') }}</h1>
      <div class="desc">
        <h2>{{ $t('aboutUBPay.content.subTitle') }}</h2>
        <p>{{ $t('aboutUBPay.content.content') }}</p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "index",
  data() {
    return {

    };
  },
  computed: {},
  methods: {},
  mounted() {

  },
};
</script>
<style scoped lang="less">

.about-container {
  padding: 40px 100px;
  .about {
    min-height: 220px;
    display: flex;
    border: 1px solid #f1f2fa;
    background-color: #f1f2fa;
    border-radius: 30px;
    .title {
      min-width: 200px;
      font-size: 34px;
      font-weight: bold;
      color: #000000;
      text-align: center;
      align-content: center;
      padding: 30px;
    }

    .desc {
      align-content: center;
      padding: 30px 20px;
      color: #000000;
      p:first-child {
        font-size: 20px;
        font-weight: bold;
        margin: 20px 0;
      }
      p:last-child {
        font-size: 18px;
        margin: 20px 0;
      }
    }
  }
}

</style>
